export default __webpack_public_path__ + "static/media/chair.f17854b1.svg";